module.exports = __webpack_public_path__ + "img/RUS.ded906a7.png";